"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceFieldValues = void 0;
var deep_copy_1 = require("./deep-copy");
// recursively replace an object's fields (by field name) by a set value
var replaceFieldValues = function (baseObject, fieldName, targetValue) {
    var base = (0, deep_copy_1.deepCopy)(baseObject);
    var entries = Object.entries(base);
    entries.forEach(function (_a) {
        var key = _a[0], value = _a[1];
        if (typeof value === 'object' && value != null) {
            base[key] = (0, exports.replaceFieldValues)(value, fieldName, targetValue);
        }
        if (key === fieldName) {
            base[key] = targetValue;
        }
    });
    return base;
};
exports.replaceFieldValues = replaceFieldValues;
